import { render, staticRenderFns } from "./dentify.vue?vue&type=template&id=51859268&scoped=true&"
import script from "./dentify.vue?vue&type=script&lang=js&"
export * from "./dentify.vue?vue&type=script&lang=js&"
import style0 from "./dentify.vue?vue&type=style&index=0&id=51859268&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51859268",
  null
  
)

export default component.exports